import { render, staticRenderFns } from "./EventComponent.vue?vue&type=template&id=12769ddb&"
import script from "./EventComponent.vue?vue&type=script&lang=js&"
export * from "./EventComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports